export const iconFontAwesomeSecurityIdBadge = (
	<i className="fa-solid fa-id-badge"></i>
);
